.a-button--primary {
	background-color: var(--dock-primary-button-color, var(--bosch-blue-50)) !important;
	color: var(--dock-primary-button-text-color, white) !important;
	border-color: var(--dock-primary-button-border-color, none) !important;
	border-radius: var(--dock-primary-button-border-radius, none) !important;

	&:hover {
		background-color: var(--dock-primary-button-hover-color, var(--bosch-blue-40)) !important;
		color: var(--dock-primary-button-text-hover-color, white) !important;
		border-color: var(--dock-primary-button-border-hover-color, none) !important;

		#accept-icon {
			path {
				fill: var(--dock-accept-icon-hover-color, white) !important;
			}
		}

		#decline-icon {
			path {
				fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}

		#options-icon {
			path {
				fill: var(--dock-options-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}
	}
}

.a-button--secondary {
	background-color: var(--dock-secondary-button-color, none) !important;
	color: var(--dock-secondary-button-text-color, var(--bosch-blue-50)) !important;
	border-color: var(--dock-secondary-button-border-color, var(--bosch-blue-50)) !important;
	border-radius: var(--dock-secondary-button-border-radius, none) !important;

	&:hover {
		background-color: var(--dock-secondary-button-hover-color, var(--bosch-blue-90)) !important;
		color: var(--dock-secondary-button-text-hover-color, var(--bosch-blue-40)) !important;
		border-color: var(--dock-secondary-button-border-hover-color, var(--bosch-blue-40)) !important;

		#accept-icon {
			path {
				fill: var(--dock-accept-icon-hover-color, white) !important;
			}
		}

		#decline-icon {
			path {
				fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}

		#options-icon {
			path {
				fill: var(--dock-options-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}
	}
}

.a-button--tertiary {
	background-color: var(--dock-tertiary-button-color, none) !important;
	color: var(--dock-tertiary-button-text-color, var(--bosch-blue-50)) !important;
	border-color: var(--dock-tertiary-button-border-color, none) !important;
	border-radius: var(--dock-tertiary-button-border-radius, none) !important;

	&:hover {
		background-color: var(--dock-tertiary-button-hover-color, var(--bosch-blue-90)) !important;
		color: var(--dock-tertiary-button-text-hover-color, var(--bosch-blue-40)) !important;
		border-color: var(--dock-secondary-button-border-hover-color, none) !important;

		#accept-icon {
			path {
				fill: var(--dock-accept-icon-hover-color, white) !important;
			}
		}

		#decline-icon {
			path {
				fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}

		#options-icon {
			path {
				fill: var(--dock-options-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}
	}
}

.small-print-link {
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	text-decoration: underline;
	color: var(--dock-small-print-link-color, var(--bosch-blue-50)) !important;

	&:hover {
		color: var(--dock-small-print-link-hover-color, var(--bosch-blue-40)) !important;
	}
}

.a-checkbox input[type="checkbox"]:checked {
	& + label::after {
		background-color: var(--dock-checkbox-color, var(--bosch-blue-50)) !important;
	}

	&:hover + label::after {
		background-color: var(--dock-checkbox-hover-color, var(--bosch-blue-40)) !important;
	}
}

.a-link {
	color: var(--dock-link-color, var(--bosch-blue-50)) !important;

	&:hover {
		color: var(--dock-link-hover-color, var(--bosch-blue-40)) !important;
	}

	a {
		text-decoration: underline !important;
	}
}

.text-bold {
	font-weight: bold;
}

#back-button {
	margin-bottom: 1rem;
	display: inline-block;
	width: auto;

	.a-button__label {
		margin: 0;
		padding: 0;
	}
}

.back-button-holder {
	margin-bottom: 0;
}

.a-box {
	max-width: 44rem;
}

.second-p {
	margin-top: 2rem;
}

.checkboxes {
	margin-top: 2.25rem;
	margin-bottom: 1rem;
}

.modal-icons {
	#accept-icon {
		margin-top: 0.5rem;
		margin-left: 0.5rem;

		path {
			fill: var(--dock-accept-icon-color, white) !important;
		}
	}

	#decline-icon {
		margin-top: 0.5rem;
		margin-left: 0.5rem;

		path {
			fill: var(--dock-decline-icon-color, var(--bosch-blue-40)) !important;
		}

		&:hover {
			fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
		}
	}

	#options-icon {
		margin-top: 0.5rem;
		margin-left: 0.5rem;

		path {
			fill: var(--dock-options-icon-color, var(--bosch-blue-40)) !important;
		}
	}

	@-moz-document url-prefix() {
		#accept-icon {
			margin-top: 0;
		}

		#decline-icon {
			margin-top: 0;
		}

		#options-icon {
			margin-top: 0;
		}
	}
}

input[type="checkbox"] {
	// Outline for keyboard navigation
	&:focus-visible + label::before {
		outline: auto;
		outline-offset: 3px;
	}
}

.options-button {
	margin-right: 42%;
}

.options-button.modal-icons {
	margin-right: auto;
}

bbg-button > button {
	width: 100%;
	margin-left: 0 !important;
}

.small-print-link {
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	font-size: var(--pwc-font-size);
	color: var(--bosch-blue-50);
}

.read-more {
	margin-top: 0.75rem;
	margin-left: 32.5px;
}

.footer {
	text-align: center;
	margin-top: 2rem;
}

.top-content {
	display: flex;
	justify-content: space-between;
}

bbg-language-selector {
	width: 50%;
}

.footer-links {
	// display: flex;
	justify-content: center;
	flex-direction: row;

	.link-holder {
		display: inline;
	}

	span:nth-child(2) {
		margin-left: 0.5rem;
	}

	span:nth-child(1) {
		margin-right: 0.5rem;
	}

	display: inline-block;

	@media (max-width: 48rem) {
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.link-holder {
			display: block;
			padding: 0.75rem 0;
			justify-content: center !important;
		}

		span:nth-child(2) {
			padding-left: 0;
			margin-top: 0;
		}

		span:after {
			display: none;
		}
	}
}

@media (max-width: 48rem) {
	.footer-links {
		span:nth-child(2) {
			margin-left: 0;
		}
	}

	.button-group {
		display: block !important;
	}

	.button-paragraph {
		margin-top: 0;
		display: block;
	}

	.options-button {
		margin-right: 0;
	}

	.options-button.modal-icons {
		margin-right: 0;
	}
}
